/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { NoveltyCalcErrorGroup } from './NoveltyCalcErrorGroup';
import {
    NoveltyCalcErrorGroupFromJSON,
    NoveltyCalcErrorGroupFromJSONTyped,
    NoveltyCalcErrorGroupToJSON,
    NoveltyCalcErrorGroupToJSONTyped,
} from './NoveltyCalcErrorGroup';
import type { NoveltyCalcResultsSummaryDto } from './NoveltyCalcResultsSummaryDto';
import {
    NoveltyCalcResultsSummaryDtoFromJSON,
    NoveltyCalcResultsSummaryDtoFromJSONTyped,
    NoveltyCalcResultsSummaryDtoToJSON,
    NoveltyCalcResultsSummaryDtoToJSONTyped,
} from './NoveltyCalcResultsSummaryDto';

/**
 * 
 * @export
 * @interface NoveltyCalcResponse
 */
export interface NoveltyCalcResponse {
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcResponse
     */
    simulationId?: number | null;
    /**
     * 
     * @type {Array<NoveltyCalcErrorGroup>}
     * @memberof NoveltyCalcResponse
     */
    errors: Array<NoveltyCalcErrorGroup>;
    /**
     * 
     * @type {NoveltyCalcResultsSummaryDto}
     * @memberof NoveltyCalcResponse
     */
    resultsSummary?: NoveltyCalcResultsSummaryDto;
}

/**
 * Check if a given object implements the NoveltyCalcResponse interface.
 */
export function instanceOfNoveltyCalcResponse(value: object): value is NoveltyCalcResponse {
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function NoveltyCalcResponseFromJSON(json: any): NoveltyCalcResponse {
    return NoveltyCalcResponseFromJSONTyped(json, false);
}

export function NoveltyCalcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationId': json['simulationId'] == null ? undefined : json['simulationId'],
        'errors': ((json['errors'] as Array<any>).map(NoveltyCalcErrorGroupFromJSON)),
        'resultsSummary': json['resultsSummary'] == null ? undefined : NoveltyCalcResultsSummaryDtoFromJSON(json['resultsSummary']),
    };
}

export function NoveltyCalcResponseToJSON(json: any): NoveltyCalcResponse {
    return NoveltyCalcResponseToJSONTyped(json, false);
}

export function NoveltyCalcResponseToJSONTyped(value?: NoveltyCalcResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationId': value['simulationId'],
        'errors': ((value['errors'] as Array<any>).map(NoveltyCalcErrorGroupToJSON)),
        'resultsSummary': NoveltyCalcResultsSummaryDtoToJSON(value['resultsSummary']),
    };
}

